import { ca } from '@cian/analytics';

import { TTrackingParamsType } from '../../types/page/trackingParamsType';

export const trackHowItsWorkClick = ({ dealType, cianSource, siteType }: TTrackingParamsType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'RentContract',
    action: 'Click_sopr',
    label: 'HowItWorks',
    page: {
      pageType: 'OnlineRentContract',
      siteType,
      extra: {
        dealType,
        cian_source: cianSource,
      },
    },
  });
};
